var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddEpisode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 9.5,
    stroke: "#303030",
    strokeDasharray: "4 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 14C23.4013 14 22.1053 15.296 22.1053 16.8947V22.1053H16.8947C15.296 22.1053 14 23.4013 14 25C14 26.5987 15.296 27.8947 16.8947 27.8947H22.1053V33.1053C22.1053 34.704 23.4013 36 25 36C26.5987 36 27.8947 34.704 27.8947 33.1053V27.8947H33.1053C34.704 27.8947 36 26.5987 36 25C36 23.4013 34.704 22.1053 33.1053 22.1053H27.8947V16.8947C27.8947 15.296 26.5987 14 25 14Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddEpisode);
export default __webpack_public_path__ + "static/media/AddEpisode.c2ce6c1ccb488c2cb4c8010340a6fbd1.svg";
export { ForwardRef as ReactComponent };